import createSetItemField from './utils/createSetItemField';
import FlagType from 'owa-service/lib/contract/FlagType';
import ItemChange from 'owa-service/lib/contract/ItemChange';
import UpdateItemResponseMessage from 'owa-service/lib/contract/UpdateItemResponseMessage';
import itemChange from 'owa-service/lib/factory/itemChange';
import itemId from 'owa-service/lib/factory/itemId';
import updateItemRequest from 'owa-service/lib/factory/updateItemRequest';
import updateItemOperation from 'owa-service/lib/operation/updateItemOperation';
import RequestOptions from 'owa-service/lib/RequestOptions';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

function createRequestBody(itemIds: string[], flagType: FlagType) {
    const update = createSetItemField('Flag', flagType);
    const itemChanges: ItemChange[] = [];
    itemIds.forEach(id =>
        itemChanges.push(
            itemChange({
                Updates: [update],
                ItemId: itemId({ Id: id }),
            })
        )
    );

    return updateItemRequest({
        ItemChanges: itemChanges,
        ConflictResolution: 'AlwaysOverwrite',
        MessageDisposition: 'SaveOnly',
    });
}

export default function flagItemService(
    itemIds: string[],
    flagType: FlagType,
    requestOptions: RequestOptions
): Promise<UpdateItemResponseMessage> {
    const requestBody = createRequestBody(itemIds, flagType);

    return updateItemOperation(
        {
            Header: getJsonRequestHeader(),
            Body: requestBody,
        },
        requestOptions
    ).then(response => {
        return response.Body.ResponseMessages.Items[0] as UpdateItemResponseMessage;
    });
}
